import React from 'react';
import SEO from '../components/SEO';
import Header from "../partials/header/Header";
import Breadcrumb from '../container/Breadcrumb/Breadcrumb';
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
// import CallToActionTwo from '../container/CallToAction/CallToActionTwo';
import Footer from '../container/Footer/Footer';
import ScrollToTop from '../components/ScrollToTop.jsx';
import EmptyTwo from '../container/Empty/EmptyTwo';
// import {Link} from "react-router-dom";

// import EmptyOne from '../container/Empty/EmptyOne';






const Submission = () => {
  return (
    <React.Fragment>
      <SEO title="Submission | DMBD 2024" />
      <Header />
      <Breadcrumb
        image="images/bg/banner2.jpg"
        title="Submission"
        content="For Authors"
        contentTwo="Submission"
        linkage="/"

      />

      {/* <HomeAbout /> */}

      <EmptyTwo>
        {/* <div align="center" className="text-submission">
          <h1>Submission of DMBD2024 will open soon</h1>
        </div> */}
        {/* DONE: add submission button */}
        <div className="row">
          <h5>Click the link below to submit your paper to DMBD 2024</h5>
          <a className="btn btn-primary btn-hover-secondary mt-xl-8 mt-lg-8 mt-md-6 mt-4" href="https://easychair.org/conferences/?conf=dmbd2024" >DMBD Online Paper Submission
          </a>
        </div>
        <p>&nbsp;</p>
        {/* <div align="center" className="text-submission">
          <p>If you can’t login the online submission system, please try to submit via
            email<a href="mailto:dmbd2024@iasei.org">dmbd2024@iasei.org</a></p>
        </div>*/}
        <p>&nbsp;</p> 
        <h3>Submission Guidelines</h3>
        <p className="home-p text-justify">Prospective authors are invited to submit full-length papers
          (10-20 pages) to DMBD 2024
          through the Online Paper Submission Systems, respectively, by the submission deadline.
          The submission of a paper implies that the paper is original and unpublished and will be
          presented by an author if accepted. Potential special track organizers are also invited
          to enlist five or more papers with cohesive topics to form special tracks.</p>
        <p className="home-p text-justify">All papers should be submitted electronically via Online
          Paper Submission Systems. The
          format of the initial submissions must be standard Springer CCIS style PDF. The files of
          the final accepted papers should be in either Word or Latex. Enquiries on paper
          submissions can be addressed to the secretariat at <a
            href="mailto:dmbd2024@iasei.org">dmbd2024@iasei.org</a>.</p>
        <p className="home-p text-justify">A complete paper should be submitted using the Springer CCIS
          template, which is
          blind-submission review-formatted template. The length should match that intended for
          final publication. Note that the DMBD 2024 reviewing is double blind, in that authors do
          not know the names of the reviewers of their papers, and reviewers do not know the names
          of the authors. Please read <a
            className='simple-link'
            href="https://resource-cms.springernature.com/springer-cms/rest/v1/content/19242230/data/"
            target="_blank"
            rel="noopener noreferrer">the Example Paper</a> for detailed instructions on how to preserve
          anonymity. Avoid providing information that may identify the authors in the
          acknowledgments (e.g., co-workers and grant IDs) and in the supplemental material. Avoid
          providing links to websites that identify the authors.</p>
        <p className="home-p text-justify">All submitted papers will be refereed double-blindly by
          experts in the respective fields
          according to the criteria of originality, significance, quality, and clarity. The
          authors of accepted papers will have an opportunity to revise their papers and take
          consideration of the referees&rsquo; comments and suggestions, before submitting the
          final camera-ready version.</p>
        <p className="home-p text-justify">Papers presented at DMBD 2024 will be published in Springer
          Communications in Computer
          and Information Science (CCIS) (indexed by EI Compendex, ISI proceedings, ISTP, DBLP,
          etc.) and some high-quality papers will be selected for several SCI-indexed journals.
        </p>


        <br></br>
        <h3>Paper Format</h3>
        <p className="home-p text-justify">Papers must be single-spaced in one column format within an
          area of 122 mm x 193 mm with
          10-point Times-Roman font. Each paper must exceed 10 pages and cannot exceed 20 pages
          including figures and references<span className="font-red font-bold"> (papers beyond 12 pages are subject to page surcharge)</span>.
          All papers must be written in English using the Springer CCIS (Communications in
          Computer and Information Science) style, including all tables, figures, and references.
          It is required that the authors use the style file of Springer CCIS (template files for <a className='simple-link'
            href="https://resource-cms.springernature.com/springer-cms/rest/v1/content/19238706/data/"
            target="_blank"
            rel="noopener noreferrer">MS Word</a> or <a className='simple-link'
              href="https://resource-cms.springernature.com/springer-cms/rest/v1/content/19238648/data/"
              target="_blank"
              rel="noopener noreferrer">LaTeX2e</a>) when preparing the manuscripts to ensure the uniformity
          of papers.
        </p>
        <p className="home-p text-justify">For detials, please visit &ldquo;<a className='simple-link'
          href="https://www.springer.com/cn/computer-science/lncs/conference-proceedings-guidelines"
          target="_blank"
          rel="noopener noreferrer">Information for Authors of Computer Science Publications</a>&rdquo;
          on the website of Springer.</p>
        <h3>Presentation Modes</h3>
        <p className="home-p text-justify">The presentation mode of a paper can be oral or poster
          depending on the preference of the
          authors and arrangement of the organizers. The authors can indicate their preferences on
          oral or poster presentation when submitting papers.</p>

        <div className="text-center">
          <a href="files/word_template.zip" target="_blank"
            className="btn btn-primary">
            <h4 >Click here to download the word template</h4>
          </a>
        </div>
        <br></br>
        <br></br>
        <br></br>
        <div className="text-center">
          <a href="files/latex_template.zip" target="_blank"
            className="btn btn-primary">
            <h4 >Click here to download the latex template</h4>
          </a>
        </div>
        {/* <h3>Copyright Form</h3> */}


        {/*         
        <h4>Instructions for Preparing Camera-Ready Copy and Uploading your Final Materials</h4>
        <div align="justify">

          <li><span className="step">Step 1:</span> Revise your paper carefully according to the
            comments of the reviewers as soon as possible. You may view the reviewers&apos;
            ratings, comments, and/or suggestions about the paper in your author&apos;s account
            of the Online Submission System at EasyChair. Please improve your writing as
            possible as you can, and proofread your final paper by a English native speaker.
          </li>
          <li><span className="step">Step 2:</span> Prepare your paper in the exact format as the
            sample paper for CCIS. Failure to do so may result in the exclusion of your
            paper from the CCIS proceedings. Please read the <a href="https://www.springer.com/gp/computer-science/lncs/conference-proceedings-guidelines">authors&apos; instructions for CCIS</a> carefully
            before preparing your papers. Each paper is allowed to have 10-15 pages in the
            final
            camera-ready copy. However, it is important that the minimum length of your
            paper must be at least 10 pages and no more than 15 pages. If your paper
            exceeds<strong> 15 </strong>pages, please pay for each additional page.</li>
          <li><span className="step">Step 3:</span> Adding ORCID Identifier. We encourage all
            contributing authors to apply for an individual ORCID at <a className="simple-link"
              href="https://www.orcid.org">www.orcid.org</a> and include them with your
            address information. (where ORCID (Open Researcher and Contributor ID) hosts a
            registry of unique researcher identifiers and a transparent method of linking
            research activities to these identifiers)</li>
          <li><span className="step">Step 4:</span> Fill out the Springer-Nature
            Copyright-Form and sign it by all authors or one representative. </li>
          <li><span className="step">Step 5:</span> Submit your final materials (source files,
            pdf, copyright form) via Online
            Submission System through your Easychair account for making Springer
            CCIS proceedings.
          </li>
        </div>
        <p>&nbsp;</p>

        <div className="text-center">
          <a href="files/word_template.zip" target="_blank"
            className="btn btn-primary">
            <h4 >Click here to download the word template</h4>
          </a>
        </div>
        <br></br>
        <br></br>
        <br></br>
        <div className="text-center">
          <a href="files/latex_template.zip" target="_blank"
            className="btn btn-primary">
            <h4 >Click here to download the latex template</h4>
          </a>
        </div>

        <h4>Instructions for submit final materials:</h4>
        <div align="justify">
          <ol>
            <li>Final source files (LaTeX or MS-Word)<ul>
              <li>For LaTeX users, please submit LaTeX files for the text and
                PS/EPS or PDF/JPG files for all figures; any further style files
                and fonts you have used together with your source files and that
                are not generally available at CTAN;<ul>
                  <li>Final DVI file (for papers prepared using LaTeX/TeX);
                  </li>
                  <li>Final PDF file (for reference);</li>
                  <li>Put these files in one folder named as latex files.</li>
                </ul>
              </li>
              <li>For Microsoft Word users, please submit final word file
                directly.</li>
            </ul>
            </li>
            <li>Scanned the signed Springer-Nature
              Copyright-Form</li>
            <li><p>Login as a proceeding author by clicking &apos;proceeding&apos; menu in your
              Easychair account</p>
            </li>
            <li>By clicking paper no.  menu in your account, you can see the detailed information of your paper for
              proceeding.</li>
            <li>Click hyperlink &apos;Update authors&apos; at the right-upper corner to update
              your authors&apos; information, and click hyperlink &apos;Upload new version&apos; at
              the right-upper corner to upload final revised paper and signed
              copyright-form for your each accepted paper.</li>
          </ol>
        </div>
        <p>&nbsp;</p>

        <h4>Presentation Modes</h4>
        <div align="justify">
          <p>The presentation mode of a paper can be oral or poster depending on the
            preference of the authors and arrangement of the organizers. The authors can
            indicate their preferences on oral or poster presentation when submitting
            papers.</p>
        </div> */}
      </EmptyTwo>
      {/* <AboutFive />
            <TestimonialContainer classOption="bg-primary-blue" />
            <CallToActionTwo /> */}
      <Footer />
      <ScrollToTop />
    </React.Fragment >
  )
}

export default Submission;



